// extracted by mini-css-extract-plugin
export default {"overlay":"ReportReason_overlay__9pupW","reasonModal":"ReportReason_reasonModal__HEV6z"};